exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".normal-table .table-head {\n  line-height: 20px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n.normal-table .orange th {\n  background-color: #ff7c4d;\n  color: #fff;\n}\n.normal-table .blue th {\n  background-color: #39b0f9;\n  color: #fff;\n}\n.normal-table .green th {\n  background-color: #50d27c;\n  color: #fff;\n}\n.normal-table tr.ark-table-row-hover td {\n  background-color: #fff;\n}\n", ""]);

// exports
